import React from 'react';
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IAdvancedStrategyFiltersEditorViewModel
} from "../../../../../services/games-filter/strategies/advanced-filter/advanced-strategy-filters-editor-view-model.interface";
import {
    IArenaGameFilterEditorViewModel
} from "../../../../../services/games-filter/arena-filters/filters/arena-game-filter-editor-view-model.interface";
import {IndicatorContainerBox} from "../../boxes/indicator-container.box";
import {BlankHorizontalSeparatorBox} from "../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {FiltersMobileButtonComponent} from "../../../../header/top-header-left/filters/filters-mobile-button.component";
import {AppliedFilterIndicatorBox} from "./boxes/applied-filter-indicator.box";
import {AppliedFiltersBox} from "./boxes/applied-filters.box";
import {RemoveFilterButtonBox} from "./boxes/remove-filter-button.box";
import {AppliedFilterNameBox} from "./boxes/applied-filter-name.box";
import {CyClass} from "../../../../../../common/cy-classes";

interface AdvancedGamesFilteringPcIndicatorComponentProps {
    filtersEditor: IAdvancedStrategyFiltersEditorViewModel;
}
export const AppliedFiltersPcIndicatorForAdvancedFilteringComponent = observer(
    class AppliedFiltersPcIndicatorForAdvancedFilteringComponent extends OrbitComponent<AdvancedGamesFilteringPcIndicatorComponentProps> {


        private _onRemoveFilter = async (filter: IArenaGameFilterEditorViewModel) => {
            filter.on = false;
            await this.props.filtersEditor.applyFilters();
        }

        private _renderOneAppliedFilter(filter: IArenaGameFilterEditorViewModel) {
            return (
                <div key={filter.id} className={CyClass('cy-applied-advanced-filter-name')}>
                    <BlankHorizontalSeparatorBox/>
                    <AppliedFilterIndicatorBox>
                        <AppliedFilterNameBox>
                            {filter.text}
                        </AppliedFilterNameBox>
                        <BlankHorizontalSeparatorBox/>
                        <RemoveFilterButtonBox onClick={() => this._onRemoveFilter(filter)} className={CyClass('cy-remove-advanced-filter-x-button')}/>
                    </AppliedFilterIndicatorBox>

                </div>

            )
        }

        private _getAppliedFilters(): IArenaGameFilterEditorViewModel[] {
            const filters: IArenaGameFilterEditorViewModel[] = [];
            this.props.filtersEditor.visibleCategories.forEach(category => {
                category.getVisibleAppliedFilters().forEach(f => {
                    if(f.on) {
                        filters.push(f);
                    }

                })
            });
            return filters;
        }

        private _renderAppliedFilters() {

            return (
                <AppliedFiltersBox>
                    {this._getAppliedFilters().map(filter => this._renderOneAppliedFilter(filter))}
                </AppliedFiltersBox>
            )
        }

        render() {
            return (
            <IndicatorContainerBox className={CyClass('cy-applied-advanced-filters-indicator')}>
                <BlankHorizontalSeparatorBox multiplier={2}/>
                <FiltersMobileButtonComponent/>

                {this._renderAppliedFilters()}

            </IndicatorContainerBox>
            );
        }
    }
);